const dealServiceSteps = {
  step_1: 0,
  step_2: 1,
  step_3: 2,
  step_4: 3,
  step_5: 4,
  step_6: 5,
};

export default dealServiceSteps;
